<template>
  <div class="url-input clearfix" v-show="show">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <input class="form-control" type="text"
          :placeholder="options.placeholder || ''"
          :id="options.name"
          :class="formControlValidationClass"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  formControlValidationClass,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'UrlInput',
  props: {
    value: {
      type: [Array, String]
    },
    options: {
      type: Object,
      default () {
        return {
          value: ''
        }
      }
    }
  },
  computed: {
    validationClass,
    formControlValidationClass,
    validationMessage,
    invalidMessage () {
      if (!this.value) {
        return this.options.label + ' is required'
      } else if (this.invalidUrls.length) {
        let message = ''
        for (let url of this.invalidUrls) {
          message += url
          if (url !== this.invalidUrls[this.invalidUrls.length - 1]) {
            message += ', '
          }
        }
        if (this.invalidUrls.length === 1) {
          message += ' is not a valid web address. Example: https://www.google.com'
        } else {
          message += ' are not valid web addresses'
        }
        return message
      }
    }
  },
  data () {
    return {
      isRegex: true,
      // regex: /^[0-9A-z./:]+[0-9A-z]{2}$/,
      regex: /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
      isValid: false,
      isDirty: false,
      watcher: false,
      show: true,
      invalidUrls: []
    }
  },
  mounted () {
    if (this.options.hidden) this.show = false
    this.validate(this.value)
    this.isDirty = false
  },
  methods: {
    validate (val = this.value) {
      if (!Array.isArray(val)) {
        val = val.split(/,\s*/)
      }
      this.$emit('input', val)
      if (val && val.length && val[0]) {
        this.isDirty = true
        this.invalidUrls = []
        for (let url of val) {
          url = url.toLowerCase()
          if (!new RegExp(this.regex).test(url)) {
            this.invalidUrls.push(url)
          }
        }
        if (this.invalidUrls.length) {
          this.isValid = this.isRegex = false
        } else {
          this.isValid = this.isRegex = true
        }
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        if (val) {
          switch (name) {
            case 'company':
              this.show = true
              this.options.required = true
              this.validate('')
              break
          }
        } else {
          switch (name) {
            // When company field is empty then remove URL field.
            case 'company':
              this.show = false
              this.options.required = false
              this.validate()
              break
          }
          this.validate('')
          this.isDirty = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/UrlInput.vue